import React from 'react'
import IBAN from 'iban'

class IbanInput extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);

        this.state = {
            value: ''
        }
    }

    onChange(e) {
        const { value, selectionStart } = e.target;
        let isValid = IBAN.isValid(value);

        const oldSpacesAfterCaret = value.substr(selectionStart, value.length - 1).split(' ').length - 1;
        const newValue = IBAN.printFormat(value.substr(0,42), ' ');

        e.persist();
        this.setState({ value: newValue }, ()=>{

            const newSpacesAfterCaret = newValue.substr(selectionStart, newValue.length - 1).split(' ').length - 1;
            // Length difference between before and after
            const diff1 = newValue.length - value.length;
            // If spaces where added deduct them from cursor position
            const diff2 = newSpacesAfterCaret - oldSpacesAfterCaret;

            if(value.length) {
                e.target.selectionStart = selectionStart + diff1 - diff2;
                e.target.selectionEnd = selectionStart + diff1 - diff2;
            }
            this.props.onChange({value, isValid});
        });

    }

    onBlur(e) {
        this.props.onBlur && this.props.onBlur(e.target.value);
    }

    render() {
        const { value } = this.state;

        return (
            <div className={['input-container', value.length === 0 ? 'is-empty' : ''].join(' ')}>
                <label htmlFor={this.props.id} className="text-nowrap">
                    {this.props.placeholder}
                </label>
                <input className="form-control"
                       type="text"
                       id={this.props.id}
                       value={value}
                       onChange={this.onChange}
                       onBlur={this.onBlur}
                       placeholder={this.props.placeholder}
                       autoComplete="off"
                />

            </div>
        )
    }
}

export default IbanInput;



// WEBPACK FOOTER //
// ./src/components/Debit/IbanInput/index.js